
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';

@Component({})
export default class RemarkField extends Vue {
  val = '';

  @Prop()
  placeholder?: string;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled?: boolean;

  @Prop()
  refs!: any;

  @Model('change', {
    type: String,
  })
  value!: string;

  @Watch('val')
  watchInternalVal(): void {
    this.$emit('change', this.val);
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = this.value;
    } else {
      this.val = '';
    }
  }

  mounted() {
    this.watchValue();
  }
}
